<div class="header">
  <div class="logo">
    <img [src]="imgSrc" alt="Gesvatec logo icono">
  </div>
  <!-- <app-breadcrumb></app-breadcrumb> -->
  <div>
    <ng-container *ngIf="isSessionActive">
      <div *ngIf="(role === 'Etiquetador') && (etiquetadores && etiquetadores.length === 1)">
        <label>{{etiquetadores[0].des}}</label>
      </div>
      <div *ngIf="(role === 'Auditor' || role === 'Supervisor') && (entidadesControl && entidadesControl.length === 1)">
        <label>{{entidadesControl[0].des}}</label>
      </div>
      <div (click)="onShowOptions()" class="singleOption">
        <i class="fas fa-user"></i>
      </div>
      <div class="singleOption">
        <i class="fas fa-comment-dots" id="icon-support-widget" title="{{'session.chatbot' | translate}}"></i>
      </div>
      <div *ngIf="role!== 'Administrador' && claims.includes('D_CNO')" (click)="onShowNotifications()" class="singleOption singleOption-notification">
        <i class="fas fa-bell"></i>
        <span *ngIf="pendingNotifications && pendingNotifications.length > 0">{{pendingNotifications.length}}</span>
      </div>
      <div *ngIf="role === 'Etiquetador'" (click)="onShowOptionsDownload()" class="singleOption">
        <i class="fa-solid fa-download"></i>
      </div>
      <section *ngIf="showOptions">
        <ul>
          <!-- <li class="disabled">
            <i class="far fa-user-circle"></i>
            <span>Perfil del usuario</span>
          </li> -->
          <li (click)="openChangeLanguageModal()">
            <i class="fas fa-globe-americas"></i>
            <span>{{'session.changeLanguage' | translate}}</span>
          </li>
          <li (click)="openChangePasswordModal()">
            <i class="fas fa-key"></i>
            <span>{{'session.changePassword' | translate}}</span>
          </li>
          <li (click)="openAppInfoModal()">
            <i class="fas fa-info-circle"></i>
            <span>{{'session.infoApp' | translate}}</span>
          </li>
          <li *ngIf="claims.includes('D_EstiloFront')" (click)="openCustomStylesModal()">
            <i class="fas fa-palette"></i>
            <span>{{'session.customStyles.titulo' | translate}}</span>
          </li>
          <li *ngIf="role === 'Auditor' || role === 'Supervisor'" (click)="openEmailSubscriptionModal()">
            <i class="fas fa-envelope"></i>
            <span>{{'session.emailSubscription' | translate}}</span>
          </li>
        </ul>
      </section>
      <section *ngIf="showOptionsDownload" class="big-section">
        <ul>
          <li class="multiple-options">
            <span [innerHTML]="'session.softwareManual' | translate"></span>
            <div>
              <i class="fa-solid fa-eye" (click)="onViewPDF('software', 1)"></i>
              <i class="fa-solid fa-download" (click)="onViewPDF('software', 2)"></i>
            </div>
          </li>
          <li class="multiple-options">
            <span [innerHTML]="'session.softwarePrerequisitos' | translate"></span>
            <div>
              <i class="fa-solid fa-eye" (click)="onViewPDF('instalation', 1)"></i>
              <i class="fa-solid fa-download" (click)="onViewPDF('instalation', 2)"></i>
            </div>
          </li>
          <!-- <li class="multiple-options">
            <span [innerHTML]="'session.sotwareInstalacion_32' | translate"></span>
            <div>
              <i class="fa-solid fa-download" (click)="onDownloadSoftware('32')"></i>
            </div>
          </li>
          <li class="multiple-options">
            <span [innerHTML]="'session.sotwareInstalacion_64' | translate"></span>
            <div>
              <i class="fa-solid fa-download" (click)="onDownloadSoftware('64')"></i>
            </div>
          </li> -->
        </ul>
      </section>
      <div class="singleOption">
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
      </div>
      <!-- "Desplegable" notificaciones pendientes -->
      <section *ngIf="showNotifications" class="pending-notifications">
        <ng-container *ngIf="pendingNotifications && pendingNotifications.length > 0">
          <article *ngFor="let notification of pendingNotifications; let i = index">
            <div>
              <span>{{notification.titulo}}</span>
              <span>{{notification.enviadoHaceFormateado}}</span>
            </div>
            <div>
              <a [routerLink]="['admin/central-notificaciones']" (click)="goToNotificationsHub(notification.id)">{{ 'session.notificaciones.verDetalle' | translate }}</a>
              <a *ngIf="i === pendingNotifications.length - 1" [routerLink]="['admin/central-notificaciones']" (click)="showNotifications = false">{{'session.notificaciones.mas' | translate}}</a>
            </div>
          </article>
        </ng-container>
        <p *ngIf="!pendingNotifications || (pendingNotifications && pendingNotifications.length === 0)">{{ 'session.notificaciones.sinNotificaciones' | translate}}</p>
      </section>
    </ng-container>
    <ng-container *ngIf="!isSessionActive && showChangeLanguage && defaultLanguage">
      <div (click)="showLanguageOptions = !showLanguageOptions">
        <i class="fas fa-globe-americas" title="{{'session.changeLanguage' | translate}}" style="padding-right: 1em;"></i>
        <label style="padding-left: unset;">{{defaultLanguage.des}}</label>
      </div>
      <section *ngIf="showLanguageOptions" class="header-changeLanguage">
        <ul>
          <li (click)="onChangeLanguage(i)" *ngFor="let language of optionsLanguage; let i=index;">
            <img src="" class={{language.classIcon}} alt={{language.des}}>
            <span>{{language.des}}</span>
          </li>
        </ul>
      </section>
    </ng-container>
    <button (click)="openModal()" class="singleOption-sign-out">
      <i [ngClass]="isSessionActive ? 'fas fa-sign-out-alt' : 'fas fa-sign-in-alt'"
          title="{{ isSessionActive ? ('session.logoutTitle' | translate) : ('session.loginTitle' | translate)}}"></i>
    </button>
  </div>
</div>
<div class="modal" *ngIf="loginModal && !isSessionActive && !_router.url.includes('viewPdf')">
  <div class="modal-content">
    <header>
      <h4>{{'session.loginTitle' | translate}}</h4>
      <i class="fas fa-times" (click)="loginModal = !loginModal"></i>
    </header>
    <app-login (closeModal)="closeModal($event)"></app-login>
  </div>
</div>
<div class="modal" *ngIf="logoutModal">
  <div class="modal-content">
    <header>
      <h4>{{'session.logoutTitle' | translate}}</h4>
    </header>
    <content>
      <p>{{'session.logoutText' |translate}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="logoutModal = !logoutModal">{{'global.cancelar' | translate}}</button>
      <button (click)="logout()">{{'global.confirmar' | translate}}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="showChangeLanguageModal">
  <div class="modal-content">
    <header>
      <h4>{{'session.changeLanguage' | translate}}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>
    <app-change-language (closeModal)="closeModal($event)"></app-change-language>
  </div>
</div>
<!-- Personalizar estilos de la web -->
<div class="modal" *ngIf="showCustomStylesModal">
  <div class="modal-content modal-size">
    <header>
      <h4>{{'session.customStyles.titulo' | translate}}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>
    <content class="custom-styles">
      <section class="custom-styles-section">
          <label>{{'session.customStyles.warningTitle' | translate}}</label>: 
          <label>{{'session.customStyles.warningText' | translate}}</label>
      </section>
      <section class="custom-styles-section">
        <form [formGroup]="customStylesForm"> 
          <div class="custom-styles-form-container">
            <div class="item-form">
              <h3 style="margin-bottom: unset;">{{'session.customStyles.estilos' | translate}}</h3>
            </div>
            <div class="item-form">
              <label>{{'session.customStyles.primaryColor' | translate}}</label>
              <button (click)="resetConcreteStyle('primaryColor')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <label class="label-color">
                <input type="color" formControlName="primaryColor"/>
              </label>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.primaryColor' | translate}}"></i>
            </div>
            <div class="item-form">
              <label>{{'session.customStyles.secondaryColor' | translate}}</label>
              <button (click)="resetConcreteStyle('secondaryColor')"><i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}</button>
              <label class="label-color">
                <input type="color" formControlName="secondaryColor"/>
              </label>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.secondaryColor' | translate}}"></i>
            </div>
            <div class="item-form">
              <label>{{'session.customStyles.tertiaryColor' | translate}}</label>
              <button (click)="resetConcreteStyle('tertiaryColor')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <label class="label-color">
                <input type="color" formControlName="tertiaryColor"/>
              </label>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.tertiaryColor' | translate}}"></i>
            </div>
            <div class="item-form">
              <label>{{'session.customStyles.tableHeaderColor' | translate}}</label>
              <button (click)="resetConcreteStyle('tableHeaderColor')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <label class="label-color">
                <input type="color" formControlName="tableHeaderColor"/>
              </label>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.tableHeaderColor' | translate}}"></i>
            </div>
            <div class="item-form">
              <label>{{'session.customStyles.subtableHeaderColor' | translate}}</label>
              <button (click)="resetConcreteStyle('subtableHeaderColor')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <label class="label-color">
                <input type="color" formControlName="subtableHeaderColor"/>
              </label>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.subtableHeaderColor' | translate}}"></i>
            </div>
            <div class="item-form">
              <h3 style="margin-bottom: unset;">{{'session.customStyles.logos' | translate}}</h3>
            </div>
            <div class="item-form-logos">
              <label>{{'session.customStyles.logoCentral' | translate}}</label>
              
              <button (click)="resetConcreteStyle('centralLogo')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              
              <button type="button" (click)="fileInput.click()">{{'session.customStyles.selectFile' | translate}}</button>
              
              <div *ngIf="getFileName('centralLogo')" class="file-name-container" (click)="removeFile('centralLogo')">
                <span class="file-name-span">{{ getFileName('centralLogo') }}</span>
                <i class="fas fa-times"></i>
              </div>
              
              <div>
                <input type="file" formControlName="centralLogo" #fileInput (change)="onFileSelected($event, 'centralLogo')" accept=".jpg, .jpeg, .png, .webp"/>
              </div>
              
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.logoCentral' | translate}}"></i>
            </div>

            <div class="item-form-logos">
              <label>{{'session.customStyles.logoBarraSup' | translate}}</label>
              <button (click)="resetConcreteStyle('topBarLogo')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <button type="button" (click)="fileInput2.click()">{{'session.customStyles.selectFile' | translate}}</button>
              <div *ngIf="getFileName('topBarLogo')" class="file-name-container" (click)="removeFile('topBarLogo')">
                <span  class="file-name-span">{{ getFileName('topBarLogo') }}</span>
                <i class="fas fa-times"></i>
              </div>
              
              <div>
                <input type="file" formControlName="topBarLogo" #fileInput2 (change)="onFileSelected($event, 'topBarLogo')" accept=".jpg, .jpeg, .png, .webp"/>
              </div>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.logoBarraSup' | translate}}"></i>
            </div>
            
            <div class="item-form-logos">
              <label>{{'session.customStyles.logoSpinner' | translate}}</label>
              <button (click)="resetConcreteStyle('spinnerLogo')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <button type="button" (click)="fileInput3.click()">{{'session.customStyles.selectFile' | translate}}</button>
              <div *ngIf="getFileName('spinnerLogo')" class="file-name-container" (click)="removeFile('spinnerLogo')">
                <span class="file-name-span">{{ getFileName('spinnerLogo') }}</span>
                <i class="fas fa-times"></i>
              </div>
              
              <div>
                <input type="file" formControlName="spinnerLogo" #fileInput3 (change)="onFileSelected($event, 'spinnerLogo')" accept=".jpg, .jpeg, .png, .webp"/>
              </div>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.logoSpinner' | translate}}"></i>
            </div>
            
            <div class="item-form-logos">
              <label>{{'session.customStyles.logoSpinnerDashboard' | translate}}</label>
              <button (click)="resetConcreteStyle('spinnerDashboardLogo')">
                <i class="fas fa-undo"></i> {{'session.customStyles.reset' | translate}}
              </button>
              <button type="button" (click)="fileInput4.click()">{{'session.customStyles.selectFile' | translate}}</button>
              <div *ngIf="getFileName('spinnerDashboardLogo')" class="file-name-container" (click)="removeFile('spinnerDashboardLogo')">
                <span class="file-name-span">{{ getFileName('spinnerDashboardLogo') }}</span>
                <i class="fas fa-times"></i>
              </div>
              
              <div>
                <input type="file" formControlName="spinnerDashboardLogo" #fileInput4 (change)="onFileSelected($event, 'spinnerDashboardLogo')" accept=".jpg, .jpeg, .png, .webp"/>
              </div>
              <i class="fa-solid fa-circle-question fa-2x" title="{{'session.customStyles.titles.logoSpinnerDashboard' | translate}}"></i>
            </div>
          </div>
        </form>
      </section>
      <section class="filters-buttons" style="gap: 1em">
          <button (click)="showCustomStylesModal = false" style="margin-bottom: unset">
            <i class="fas fa-times"></i> {{ 'global.cancelar' | translate }}
          </button>
          <button (click)="resetAllStyles()" style="margin-bottom: unset">
              <i class="fas fa-sync"></i> {{'session.customStyles.resetChanges' | translate}}
          </button>
          <button (click)="confirmCustomStyles()" style="margin-bottom: unset">
              <i class="fas fa-check"></i> {{'session.customStyles.confirmChanges' | translate}}
          </button>
      </section>
    </content>
  </div>
</div>
<div class="modal" *ngIf="changePasswordModal && chngPsswdCloseModal">
  <div class="modal-content">
    <header>
      <h4>{{'session.changePassword' | translate}}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>
    <app-change-password [email]="userEmail" [guid]="userGuid" [recovery]="true" (closeModal)="closeChangePwdModal($event)" (closeOptions)="closeOptions($event)" (pushMessage)="pushMessage($event)">
    </app-change-password>
  </div>
</div>
<div class="modal" *ngIf="showChangePasswordModal">
  <div class="modal-content">
    <header>
      <h4>{{'session.changePassword' | translate}}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>
    <app-change-password [email]="userEmail" [guid]="userGuid" (closeModal)="closeChangePwdModal($event)" (closeOptions)="closeOptions($event)" (pushMessage)="pushMessage($event)">
    </app-change-password>
  </div>
</div>
<div class="modal" *ngIf="showAppInfoModal">
  <div class="modal-content">
    <header>
      <h4>{{'session.infoApp' | translate}}</h4>
      <i class="fas fa-times" (click)="showAppInfoModal = !showAppInfoModal"></i>
    </header>
    <content>
      <section class="appInfo">
        <label>Angular {{angularVersion}}</label>
        <div class="entry-single">
          <label>{{'infoApp.version' | translate}}</label>
          <span>{{version}}</span>
        </div>
        <div class="entry-single">
          <label>{{'infoApp.fechaPubli' | translate}}</label>
          <span>{{fecha | date: 'short' : undefined : languageWeb}}</span>
        </div>
        <div class="entry-single">
          <label>{{'infoApp.currentLanguage' | translate}}</label>
          <span>{{defaultLanguage.des}}</span>
        </div>
        <div class="entry-single">
          <label>{{'infoApp.timeZone' | translate}}</label>
          <span>{{sessionUser.msTimeZoneId}}</span>
        </div>
      </section>
    </content>
  </div>
</div>

<!-- Envío de alertas por email -->
<div class="modal" *ngIf="showEmailSubscriptionModal">
  <div class="modal-content">
    <header>
      <h4>{{ 'emailSubscription.title' | translate }}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>

    <app-email-subscription (pushMessage)="pushMessage($event)" (refresh)="closeModal(false)"></app-email-subscription>
  </div>
</div>

<div class="modal" *ngIf="confirmRegistrationModal">
  <div class="modal-content">
    <header>
      <h4>{{'usuarios.confirmarRegistro.des' | translate}}</h4>
      <i class="fas fa-times" (click)="closeModal(false)"></i>
    </header>
    <app-confirm-registration [guid]="userGuid" (closeModal)="closeModal($event)">
    </app-confirm-registration>
  </div>
</div>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event" [ngStyle]="{'z-index': showCustomStylesModal ? '989' : '', 'position': showCustomStylesModal ? 'relative' : ''}"></app-toast>
